// Copyright (c) 2026, Dokos SAS and Contributors
// License: GNU General Public License v3. See license.txt

frappe.provide("frappe.ui.form");

frappe.ui.form.LeaveApplicationQuickEntryForm = class LeaveApplicationQuickEntryForm extends (
	frappe.ui.form.QuickEntryForm
) {
	set_meta_and_mandatory_fields() {
		super.set_meta_and_mandatory_fields();

		// Only surface the fields an employee actually needs to fill in.
		// company / department / employee_name are fetched silently from the
		// employee record before saving; posting_date / status / naming_series
		// are set by server defaults.
		const VISIBLE = [
			"employee",
			"leave_type",
			"from_date",
			"to_date",
			"half_day",
			"half_day_date",
			"description",
		];
		this.docfields = this.docfields.filter((df) => VISIBLE.includes(df.fieldname));

		// Wire onchange before the dialog fields are instantiated so Frappe's
		// field system picks them up automatically.
		this.docfields.forEach((df) => {
			if (df.fieldname === "employee") {
				df.onchange = () => this._on_employee_change();
			}
			if (df.fieldname === "from_date") {
				df.onchange = () => this._refresh_balance();
			}
			if (df.fieldname === "leave_type") {
				df.onchange = () => this._highlight_selected_type();
			}
		});
	}

	render_dialog() {
		super.render_dialog();
		this._inject_balance_panel();
		this._prefill_employee();
	}

	// ── Balance panel ────────────────────────────────────────────────────────

	_inject_balance_panel() {
		this.$balance_panel = $(`
			<div class="la-balance-panel" style="
				margin: 0 0 18px;
				padding-bottom: 16px;
				border-bottom: 1px solid var(--border-color);
			">
				<div style="
					font-size: 11px;
					font-weight: 600;
					color: var(--text-muted);
					text-transform: uppercase;
					letter-spacing: 0.6px;
					margin-bottom: 10px;
				">${__("Leave Balances")}</div>
				<div class="la-balance-content" style="color: var(--text-muted); font-size: 13px;">
					${__("Loading…")}
				</div>
			</div>
		`);
		// Inject above the form fields
		$(this.body).prepend(this.$balance_panel);
	}

	_render_balance(allocation) {
		this._allocation = allocation;
		const $content = this.$balance_panel.find(".la-balance-content");

		if (!allocation || jQuery.isEmptyObject(allocation)) {
			$content.html(
				`<span style="color: var(--text-muted);">${__("No leaves allocated.")}</span>`,
			);
			return;
		}

		const html = frappe.render_template("leave_application_dashboard", { data: allocation });
		$content.html(html);
		this._highlight_selected_type();
	}

	_highlight_selected_type() {
		if (!this._allocation) return;
		const selected = this.fields_dict.leave_type?.get_value();
		this.$balance_panel.find("[data-leave-type]").each(function () {
			const $card = $(this);
			const active = $card.data("leave-type") === selected;
			$card.css({
				"border-color": active ? "var(--primary, #2490EF)" : "var(--border-color)",
				"box-shadow": active ? "0 0 0 2px rgba(36,144,239,0.15)" : "none",
			});
		});
	}

	_setup_leave_type_filter(allocation, lwps) {
		const allowed = Object.keys(allocation).concat(lwps || []);
		const lt_field = this.fields_dict.leave_type;
		if (lt_field && allowed.length) {
			lt_field.df.get_query = () => ({
				filters: [["leave_type_name", "in", allowed]],
			});
		}
	}

	// ── Employee & dependencies ──────────────────────────────────────────────

	async _prefill_employee() {
		if (this.doc.employee) {
			await this._sync_employee_fields(this.doc.employee);
			return;
		}
		const employee = await hrms.get_current_employee(this);
		if (employee) {
			this.fields_dict.employee?.set_value(employee);
			// set_value triggers onchange → _on_employee_change handles the rest
		} else {
			this.$balance_panel
				.find(".la-balance-content")
				.html(
					`<span style="color: var(--text-muted);">${__(
						"Select an employee to see leave balances.",
					)}</span>`,
				);
		}
	}

	async _on_employee_change() {
		const employee = this.fields_dict.employee?.get_value();
		if (!employee) return;
		await this._sync_employee_fields(employee);
	}

	async _sync_employee_fields(employee) {
		// Silently populate read-only fetch_from fields that won't appear in
		// the dialog but are required by server validation.
		const result = await frappe.db.get_value("Employee", employee, [
			"company",
			"department",
			"employee_name",
		]);
		if (result?.message) {
			Object.assign(this.doc, {
				employee,
				company: result.message.company,
				department: result.message.department,
				employee_name: result.message.employee_name,
			});
		}
		this._refresh_balance();
	}

	_refresh_balance() {
		const employee = this.fields_dict.employee?.get_value() || this.doc.employee;
		if (!employee) return;

		const date = this.fields_dict.from_date?.get_value() || frappe.datetime.get_today();

		frappe.call({
			method: "hrms.hr.doctype.leave_application.leave_application.get_leave_details",
			args: { employee, date },
			callback: (r) => {
				if (!r.message) return;
				this._render_balance(r.message.leave_allocation || {});
				this._setup_leave_type_filter(r.message.leave_allocation || {}, r.message.lwps);
			},
		});
	}
};
